var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __reExport = (target, module2, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2))
      if (!__hasOwnProp.call(target, key) && key !== "default")
        __defProp(target, key, { get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable });
  }
  return target;
};
var __toModule = (module2) => {
  return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", module2 && module2.__esModule && "default" in module2 ? { get: () => module2.default, enumerable: true } : { value: module2, enumerable: true })), module2);
};
__export(exports, {
  buildDoubleExpression: () => buildDoubleExpression,
  isDoubleExpression: () => isDoubleExpression
});
var import_mathFunctionError = __toModule(require("../../../../error/mathFunctionError"));
const DOUBLE_FUNCTIONS = [
  "adjustMatrix",
  "appendMatrixNumber",
  "appendMatrixText",
  "concatenate",
  "concatenateMatrices",
  "concatenateMatrix",
  "containText",
  "containTextMatrices",
  "containTextMatrix",
  "dateCalculateDays",
  "dateCalculateDaysMatrices",
  "dateCalculateDaysMatrix",
  "elementMatrixNumber",
  "elementMatrixText",
  "equalMatrix",
  "equalText",
  "equalTextMatrix",
  "hasNotValueChangedNumber",
  "hasNotValueChangedText",
  "includeEqualTextMatrices",
  "includeTextMatrices",
  "indexOfMatrices",
  "indexOfMatrix",
  "indexFirstTextValueMatrix",
  "indexFirstTextValueMatrices",
  "indexMaximumMatrix",
  "indexMaximumMatrices",
  "indexMinimumMatrix",
  "indexMinimumMatrices",
  "indexSumMatrix",
  "indexSumMatrices",
  "largerEqMatrix",
  "largerMatrix",
  "largerMatrix",
  "leftNumber",
  "leftNumberMatrix",
  "leftText",
  "leftTextMatrix",
  "matchNumberMatrices",
  "matchNumberMatrix",
  "matchTextMatrices",
  "matchTextMatrix",
  "notEqualMatrix",
  "notContainText",
  "notContainTextMatrices",
  "notContainTextMatrix",
  "notIncludeEqualTextMatrices",
  "notIncludeTextMatrices",
  "percentage",
  "rightNumber",
  "rightNumberMatrix",
  "rightText",
  "rightTextMatrix",
  "smallerEqMatrices",
  "smallerEqMatrix",
  "smallerMatrices",
  "smallerMatrix",
  "unequalMatrix",
  "unequalText",
  "unequalTextMatrix"
];
const isDoubleExpression = (functionName) => {
  return DOUBLE_FUNCTIONS.includes(functionName);
};
const buildDoubleExpression = (functionName, operands1 = [], operands2 = []) => {
  if (!isDoubleExpression(functionName)) {
    throw new import_mathFunctionError.MathFunctionError(`Function ${functionName}. Not a double function`);
  }
  if (operands1.length > 1 || operands2.length > 1) {
    const message = `Function ${functionName}. Double operator with invalid operands size: 1=${operands1.length}, 2=${operands2.length}`;
    throw new import_mathFunctionError.MathFunctionError(message);
  }
  const [firstOperand] = operands1;
  const [secondOperand] = operands2;
  if (firstOperand === void 0) {
    const message = `Invalid first operand for ${functionName}: 1=${firstOperand}, 2=${secondOperand}`;
    throw new import_mathFunctionError.MathFunctionError(message);
  }
  if (secondOperand === void 0) {
    const message = `Invalid second operand for ${functionName}: 1=${firstOperand}, 2=${secondOperand}`;
    throw new import_mathFunctionError.MathFunctionError(message);
  }
  return `${functionName}(${firstOperand}, ${secondOperand})`;
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  buildDoubleExpression,
  isDoubleExpression
});
